// extracted by mini-css-extract-plugin
module.exports = {"page":"Login_page_1nmPi"};